import StatusBadge from "@/components/StatusBadge";
import { booleanOptionIconLabels } from "@/constant/GeneralOptions/boolean";
import { DATE_FORMAT } from "@/constant/Tables/date-format";
import { userStatusBgColors, userStatusLabels } from "@/constant/Users/status";
import { userTypeLabels } from "@/constant/Users/types";
import { formatNumber, truncate } from "@/utils/helper";
import Actions from "./Actions";

export const columns = (columnConfigs = null) => {
  // const booleanOptionLabelsMap = booleanOptionIconLabels();
  // const userStatusLabelMap = userStatusLabels;
  // const userStatusBgColorMap = userStatusBgColors;
  // const userTypeLabelMap = userTypeLabels();

  // const dateFormat = columnConfigs?.date_format;

  const allColumns = [
    {
      accessorKey: "transaction_id",
      header: "Transaction ID",
      headerColor: "bg-red-200",
    },
    {
      accessorKey: "purchase_status",
      header: "Purchase Status",
      headerColor: "bg-red-200",
      // cell: ({ row }) => (
      //   <StatusBadge
      //     status={row.getValue("Purchase Status")}
      //     // statusLabelMap={userStatusLabelMap}
      //     // statusBgColorMap={userStatusBgColorMap}
      //   />
      // ),
    },
    {
      accessorKey: "shipping_type",
      header: "Shipping Type",
      headerColor: "bg-red-200",
    },
    {
      accessorKey: "order_date",
      header: "Order Date",
      headerColor: "bg-red-200",
    },
    {
      accessorKey: "shipping_date",
      header: "Shipping Date",
      headerColor: "bg-red-200",
    },
    {
      accessorKey: "arrival_date",
      header: "Arrival Date",
      headerColor: "bg-red-200",
    },
    {
      accessorKey: "cancelation_date",
      header: "Cancelation Date",
      headerColor: "bg-red-200",
    },
    {
      accessorKey: "base_product",
      header: "Base Product",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "product",
      header: "Product",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "team",
      header: "Team",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "competition",
      header: "Competition",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "term",
      header: "Term",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "edition",
      header: "Edition",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "version",
      header: "Version",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "name",
      header: "Name",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "number",
      header: "Number",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "brand",
      header: "Brand",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "color",
      header: "Color",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "material",
      header: "Material",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "condition",
      header: "Condition",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "gender",
      header: "Gender",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "size",
      header: "Size",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "sleeve",
      header: "Sleeve",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "patches",
      header: "Patches",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "signed",
      header: "Signed",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "match_worn",
      header: "Match Worn",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "display_case",
      header: "Display Case",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "extra_print",
      header: "Extra Print",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "extra_patch",
      header: "Extra Patch",
      headerColor: "bg-yellow-100",
    },
    {
      accessorKey: "sale_type",
      header: "Sale Type",
      headerColor: "bg-blue-200",
    },
    {
      accessorKey: "product_price",
      header: "Product Price",
      headerColor: "bg-blue-200",
    },
    {
      accessorKey: "extra_print_fee",
      header: "Extra Print Fee",
      headerColor: "bg-blue-200",
    },
    {
      accessorKey: "extra_patch_fee",
      header: "Extra Patch Fee",
      headerColor: "bg-blue-200",
    },
    {
      accessorKey: "shipping_fee",
      header: "Shipping Fee",
      headerColor: "bg-blue-200",
    },
    {
      accessorKey: "buyer_jm_fee",
      header: "Buyer JM Fee",
      headerColor: "bg-blue-200",
    },
    {
      accessorKey: "seller_jm_fee",
      header: "Seller JM Fee",
      headerColor: "bg-blue-200",
    },
    {
      accessorKey: "ryft_fee",
      header: "Ryft Fee",
      headerColor: "bg-blue-200",
    },
    {
      accessorKey: "jm_revenue",
      header: "JM Revenue",
      headerColor: "bg-blue-200",
    },
    {
      accessorKey: "currency",
      header: "Currency",
      headerColor: "bg-blue-200",
    },
    {
      accessorKey: "gift_card",
      header: "Gift Card",
      headerColor: "bg-blue-200",
    },
    {
      accessorKey: "payment_method",
      header: "Payment Method",
      headerColor: "bg-blue-200",
    },
    {
      accessorKey: "seller_username",
      header: "Seller Username",
      headerColor: "bg-green-100",
    },
    {
      accessorKey: "seller_location",
      header: "Seller Location",
      headerColor: "bg-green-100",
    },
    {
      accessorKey: "seller_type",
      header: "Seller Type",
      headerColor: "bg-green-100",
    },
    {
      accessorKey: "seller_rating",
      header: "Seller Rating",
      headerColor: "bg-green-100",
    },
    {
      accessorKey: "buyer_username",
      header: "Buyer Username",
      headerColor: "bg-green-100",
    },
    {
      accessorKey: "buyer_location",
      header: "Buyer Location",
      headerColor: "bg-green-100",
    },
  ];

  const filteredColumns = columnConfigs
    ? allColumns
        .filter((column) =>
          columnConfigs?.columns?.includes(column.accessorKey ?? column.id)
        )
        .sort((a, b) => {
          const selectedColumns = columnConfigs?.columns;
          const indexA = selectedColumns.indexOf(a.accessorKey ?? a.id);
          const indexB = selectedColumns.indexOf(b.accessorKey ?? b.id);
          return indexA - indexB;
        })
    : allColumns;

  return filteredColumns;
};
